// extracted by mini-css-extract-plugin
module.exports = {"modalContentContainer":"mU9S-","bold":"_1FTyR","link":"_2cO9L","confirmButton":"_2aak6"};